import { Avatar as MuiAvatar } from '@material-ui/core'
import { User } from '@popmenu/web-icons'
import React, { forwardRef } from 'react'
import { Icon } from '../Icon'

import { AvatarProps, StyledAvatarProps } from './AvatarProps'
import { useAvatarStyles } from './avatar.styles'
import { useImgProps } from './util/useImageProps'

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(
  ({ size = 'medium', fit = 'cover', background = '#E0E0E0', ...restProps }, ref) => {
    const props = { ...restProps, size, fit, background }
    const { children, src, alt, fallback, ...muiProps } = props
    const { imgProps, loaded } = useImgProps(props)
    const classes = useAvatarStyles({ ...props, loaded } as StyledAvatarProps)
    const displayAltTextFallback = src && alt
    const displayNoFallback = fallback === 'none'
    const displayCustomFallback = fallback !== 'none' && typeof fallback !== 'undefined'
    let Fallback
    if (displayAltTextFallback) {
      Fallback = null
    } else if (displayNoFallback) {
      Fallback = ' '
    } else if (displayCustomFallback) {
      Fallback = fallback
    } else {
      Fallback = <Icon icon={User} className={classes.fallback} />
    }
    return (
      <MuiAvatar ref={ref} classes={{ root: classes.root }} src={src} alt={alt} {...muiProps} imgProps={imgProps}>
        {children || Fallback}
      </MuiAvatar>
    )
  },
)

Avatar.displayName = 'Avatar'
